import { render, staticRenderFns } from "./SyncMappingCard.vue?vue&type=template&id=331b3ff9"
import script from "./SyncMappingCard.vue?vue&type=script&lang=js"
export * from "./SyncMappingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports